import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'dmv-pub-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterComponent {
    public phone: string = environment.contactInfo.phoneNumber;

    public openCookieSettings(): void {
        window.revisitCkyConsent?.();
    }
}
